import { useState } from "react";

import styles from "../../_styles/InfoBlock.module.scss";
import ChooseInfoBlock from "../rightData/ChooseInfoBlock";
import ButtonIcon from "../../../../components/icons/ButtonIcon";
import { useGetVideoDetailsQuery } from "../../../../store/api/filmAPI";
import { useTranslation } from "react-i18next";
import useLikeClick from "../../../../hooks/useLikeClick";
import useFavouriteClick from "../../../../hooks/useFavouriteClick";
import { useDispatch } from "react-redux";
import { setShareModal } from "../../../../store/slices/modals.slice";
import { languageHandler } from "../../../../utils/helpers";
import useShareClick from "../../../../hooks/useShareClick";

interface IProps {
  currentItemId: number;
  clickHandler: () => void;
  inViewport: boolean;
  item: any;
}

const ChooseFooter = ({ currentItemId, clickHandler, inViewport, item }: IProps) => {
  const [hoverButton, setHoverButton] = useState(false);

  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const { likesList, likeHandler } = useLikeClick();
  const { favoritesList, favouritesHandler } = useFavouriteClick();
  const { shareList } = useShareClick();

  const { data, isLoading } = useGetVideoDetailsQuery(
    {
      queries: { language: languageHandler(i18n.language) },
      id: currentItemId,
    },
    {
      skip: !inViewport,
    },
  );

  if (isLoading) {
    return <div />;
  }

  const shareHandler = () => {
    dispatch(setShareModal(true));
  };

  return (
    <div className={styles.footerContent}>
      <ChooseInfoBlock
        item={item}
        likeHandler={likeHandler}
        liked={likesList.data?.results.includes(data?.id)}
        shared={shareList.data?.results.includes(data?.id)}
        reviewHandler={clickHandler}
        favouritesHandler={favouritesHandler}
        shareHandler={shareHandler}
        inFavourites={favoritesList.data?.results.includes(data?.id)}
      />
      <button
        onClick={clickHandler}
        className={styles.footerContentButton}
        onMouseLeave={() => setHoverButton(false)}
        onMouseEnter={() => setHoverButton(true)}
      >
        <ButtonIcon stroke={hoverButton} />
      </button>
    </div>
  );
};

export default ChooseFooter;
